import { Injectable } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { Pin } from 'app/providers/bridge-api/dashboard.service';

@Injectable({ providedIn: 'root' })
export class PinningService {
  private readonly _data = new ReplaySubject<Pin[]>(1);

  readonly data$ = this._data.asObservable();

  set(pins: Pin[]): void {
    this._data.next(pins);
  }
}
